import React from "react";
import Breadcrumb from "../../../components/layout/Breadcrumb";
import { Divider } from "@mui/material";
import RoleForm from "../../../features/roles/RoleForm";
import RoleTable from "../../../features/roles/RoleTable";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PermissionUserList from "../../../features/portal/permission/PermissionUserList";
import { useHasPermission } from "../../../hooks/useHasPermission";
import { useSearchParams } from "react-router-dom";

function Role() {
  const canViewRole = useHasPermission("Role-view");
  const canViewPermission = useHasPermission("Permission-view");
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "role";

  return (
    <div className="user-role_section">
      <div className="role-perm-tab">
        <Breadcrumb />
        <ul className="nav">
          <li className="nav-item">
            <button
              className={`toggle-first-btn nav-link ${activeTab === "role" ? "btn-active" : "inactive"}`}
              title={canViewRole ? "show role table" : "No permission to show role table"}
              disabled={!canViewRole}
              onClick={canViewRole ? () => setSearchParams({ tab: "role"}) : undefined}
            >
              Role
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`toggle-second-btn nav-link ${activeTab === "permission" ? "btn-active" : "inactive"}`}
              title={canViewPermission ? "show permission table" : "No permission to show permission table"}
              disabled={!canViewPermission}
              onClick={canViewPermission ? () => setSearchParams({ tab: "permission"}) : undefined}
            >
              Permission
            </button>
          </li>
        </ul>
      </div>
      <br />
      {activeTab === "role" && canViewRole && (
        <>
          <RoleForm />
          <Divider sx={{ my: 1 }} />
          <RoleTable />
        </>
      )}

      {activeTab === "permission" && canViewPermission && (
        <PermissionUserList />
      )}

      <ToastContainer />
    </div>
  );
}

export default Role;
